// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import VueSignaturePad from 'vue-signature-pad'
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import { i18n } from './lang'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn',
}

miniToastr.init({ types: toastTypes })

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
}

Vue.use(VueNotifications, options)

Vue.use(VeeValidate, {
  errorBagName: 'veeErrors',
  inject: true,
  fieldsBagName: 'veeFields',
})

Vue.use(VueCookies)
Vue.use(VueSignaturePad)
Vue.use(Vuex)

/**
 * Formats a phone number.
 * Example: +1-720-456-7890 => (720) 456-7890
 *
 * @param {String} phone
 * @return {Void}
 */
Vue.filter('phone', function (phone) {
  if (!phone) {
    return ''
  }
  return phone
    .replace(/[^0-9]/g, '')
    .replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '($2) $3-$4')
})

Vue.use(BootstrapVue)

/* eslint-disable no-new */
window.TECOBI = window.TECOBI || {}

// Mount the Soft Pull app
window.TECOBI.mountTECOBISoftPullApp = () => {
  console.log('Mounting TECOBI Soft Pull App')
  const mountEl = document.getElementById('tecobi-soft-pulls')
  window.TECOBI.clientId = mountEl ? mountEl.getAttribute('data-client-id') : '5' // Default to 5 if not found

  if (!window.TECOBI.clientId) {
    console.error('No client ID provided')
    return false
  }

  new Vue({
    el: '#tecobi-soft-pulls',
    router,
    store,
    template: '<App/>',
    i18n,
    components: { App },
  })

  // Default the app to the quick-qualify route
  router.replace(`/quick-qualify/${window.TECOBI.clientId}`)
}

// Mount the Credit App
window.TECOBI.mountTECOBICreditApp = () => {
  console.log('Mounting TECOBI Credit App')
  const mountEl = document.getElementById('tecobi-credit-app')
  window.TECOBI.clientId = mountEl ? mountEl.getAttribute('data-client-id') : null

  if (!window.TECOBI.clientId) {
    console.log('No client ID')
    return false
  }

  new Vue({
    el: '#tecobi-credit-app',
    router,
    store,
    template: '<App/>',
    i18n,
    components: { App },
  })

  // Default the app to the credit app route
  router.replace(`/creditapp/${window.TECOBI.clientId}`)
}

// Check for which app to mount
 window.TECOBI.doMount = () => {
  const softPullsEl = document.getElementById('tecobi-soft-pulls')
  const creditAppEl = document.getElementById('tecobi-credit-app')
  console.log('creditAppEl', creditAppEl);
  console.log('softPullsEl', softPullsEl);
  if (softPullsEl) {
    window.TECOBI.mountTECOBISoftPullApp()
  } else if (creditAppEl) {
    window.TECOBI.mountTECOBICreditApp()
  } else {
    console.log('No TECOBI app element found on the page.')
  }
}


//document.addEventListener('DOMContentLoaded', () => window.TECOBI.doMount())
window.TECOBI.doMount();
// Redirect old host
window.TECOBI.isTecobiHost = window.location.href.indexOf('https://creditapp.tecobi.com') !== -1
if (window.TECOBI.isTecobiHost) {
  window.location.href = window.location.href.replace('https://creditapp.tecobi.com', 'https://credit.tecobi.com')
}
